import { SettingConst } from '../../types';

/**
 * Emergency stop for the AI chatbot in the Help Center.
 * If set to `true`, the user will see the normal self-serve flow instead of the chatbot.
 */
export const HELP_CENTER_AI_CHATBOT_EMERGENCY_STOP =
  'HELP_CENTER_AI_CHATBOT_EMERGENCY_STOP' as SettingConst<
    'HELP_CENTER_AI_CHATBOT_EMERGENCY_STOP',
    boolean,
    'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
